import styled from 'styled-components';

export const Inputs = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	width: 100%;
`;

export const Wrapper = styled.div`
	width: 100%;
`;
